"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createLocalEnvironment;

var _relayRuntime = require("relay-runtime");

var _createRelayStore = _interopRequireDefault(require("./createRelayStore"));

var _RelayLogger = _interopRequireDefault(require("./RelayLogger"));

/**
 * This is just an alternative environment factory for LocalQueryRenderer. There is currently not
 * very much API around and should be extended as needed.
 */
function createLocalEnvironment() {
  // $FlowExpectedError[prop-missing]: Network is required in relay flow types
  return new _relayRuntime.Environment({
    // notice this environment doesn't have network layer since it's not necessary
    log: _RelayLogger.default,
    store: (0, _createRelayStore.default)()
  });
}